<div class="table-heading-options">
  <button
    type="button"
    class="filters-applied-btn"
    (click)="toggleMenu($event)"
    [attr.aria-expanded]="showMenu"
  >
    <mat-icon svgIcon="funnel" class="filters-applied-icon"></mat-icon>
    <p>Filters applied</p>
    <ng-container *ngIf="totalFiltersApplied > 0">
      <div class="filters-applied-btn-badge">
        <p>{{ totalFiltersApplied }}</p>
      </div>
    </ng-container>
    <mat-icon svgIcon="caret-down" class="header-caret"></mat-icon>
  </button>
</div>

<core-contextmenu
  *ngIf="showMenu && totalFiltersApplied > 0"
  id="filter"
  open
  class="header-menu"
  (openChange)="closeMenu()"
>
  <ng-container *ngFor="let filterColumn of filtersAppliedArray; trackBy: trackByKey">
    <p class="header-menu-title-filter">{{ columnTitleMappings[filterColumn.key] }}</p>
    <ng-container *ngFor="let filter of filterColumn.value; trackBy: trackByFilter">
      <div class="header-menu-item-filter">
        <core-contextmenu-item
          variant="default"
          height="40px"
          [label]="filter"
          ngClass="header-menu-item-filter"
        >
        </core-contextmenu-item>
        <button type="button" (click)="removeFilter(filter, filterColumn.key)">
          <mat-icon svgIcon="close" class="header-cross-icon"></mat-icon>
        </button>
      </div>
    </ng-container>
  </ng-container>
  <div class="header-menu-footer">
    <p>{{ totalFiltersApplied }} selected</p>
    <div class="header-menu-footer-actions">
      <button (click)="clearAllFilters()">Clear All</button>
    </div>
  </div>
</core-contextmenu>
